import React, { FC, Fragment, useState, useMemo } from 'react'
import Link from 'next/link'
import { ChevronDown, ChevronUp } from 'react-feather'
import { useTranslation } from 'next-i18next'
import { Button } from '@corratech/pylot-ui'
import cn from 'classnames'
import s from '@pagestyles/Account.module.scss'
import { useRouter } from 'next/router'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import {
    Dashboard,
    Contract,
    AccountProfile,
    AddBook,
    Orders,
    StoreCredit,
    SavedCard
} from '@components/common/AccountSidebar/icons'
import { Heart } from '@components/icons'
import { getStoreLevelTabs } from '@components/common/AccountSidebar/getStoreLevelTabs'

export const AccountSidebar: FC = () => {
    const [display, setDisplay] = useState(false)
    const { t } = useTranslation(['account'])
    const router = useRouter()
    const config = useStoreConfig()
    const sideBarConfig = [
        {
            name: t('account|My Account'),
            path: '/account',
            class: 'account-icon',
            icon: Dashboard,
            enable: true
        },
        {
            name: t('account|My Orders'),
            path: '/account/orders',
            class: 'order-icon',
            icon: Orders,
            enable: true
        },
        {
            name: t('account|My Wish List'),
            path: '/account/wishlist',
            class: 'wishlist-icon',
            icon: Heart,
            enable: config.base.wishlist.enabled
        },
        {
            name: t('account|My Rewards & Referrals'),
            path: '/account/rewards',
            class: 'newsletter-icon',
            icon: StoreCredit,
            enable: config?.base?.yotpoLoyalty?.enabled
        },
        {
            name: t('account|Address Book'),
            path: '/account/address',
            class: 'address-icon',
            icon: AddBook,
            enable: true
        },
        {
            name: t('account|Saved Cards'),
            path: '/account/saved-cards',
            class: 'address-icon',
            icon: SavedCard,
            enable: true
        },
        {
            name: t('account|Account Information'),
            path: '/account/account-information',
            class: 'account-information-icon',
            icon: AccountProfile,
            enable: true
        },
        {
            name: t('account|Communications'),
            path: '/account/newsletter',
            class: 'newsletter-icon',
            icon: Contract,
            enable: true
        },
        ...getStoreLevelTabs(t)
    ]

    //logic to strip account from the url to avoid selection of /account/ page
    const getActiveLinks = (link: string): boolean => {
        const hrefLink = link.replace('/account/', '')
        const routePath = router.pathname.replace('/account/', '')
        return routePath.indexOf(hrefLink) !== -1
    }

    const sidebarLink = useMemo(() => {
        return sideBarConfig.map((value, index) => (
            <Fragment key={index}>
                {value?.enable && (
                    <li
                        className={cn({
                            [s.active]: getActiveLinks(value.path)
                        })}
                    >
                        <Link href={value.path}>
                            <Button
                                variant="link"
                                className={s['sidebar-links']}
                            >
                                <span
                                    className={cn(
                                        s['item-icon'],
                                        s[value.class]
                                    )}
                                >
                                    <value.icon />
                                </span>
                                <span className={s['item-name']}>
                                    {value.name}
                                </span>
                            </Button>
                        </Link>
                    </li>
                )}
            </Fragment>
        ))
    }, [getActiveLinks, sideBarConfig])

    return (
        <>
            <h2
                onClick={() => setDisplay(!display)}
                // eslint-disable-next-line i18next/no-literal-string
                aria-hidden="true"
                className={s['sidebar-title']}
            >
                {t('account|My Account')}
                <span className="float-right">
                    {display ? (
                        <ChevronUp size={25} />
                    ) : (
                        <ChevronDown size={25} />
                    )}
                </span>
            </h2>
            <div className={cn(display ? s['sidebar-open'] : s.sidebar)}>
                <div className={s['sidebar-inner']}>
                    <ul>{sidebarLink}</ul>
                </div>
            </div>
        </>
    )
}
